<div class="expandable-children">
  <div class="children-scroll-container">
    @for (child of children(); track $index) {
      <a
        class="child-item fs-body-s"
        [routerLink]="child.url"
        [routerLinkActive]="'active'"
        (click)="onChildClick($event, child)"
        tabindex="0"
        role="button"
      >
        <span class="child-title">{{ child.title }}</span>
      </a>
    }
  </div>
</div>
